import React, { useState, useCallback } from 'react';
// import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { SuiContainer, SuiCollapsible } from '@splashthat/sui';

import {
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_TIME,
} from 'common/entities/formNode/nodeNames';

import { InputTypeControlDisableable } from '../components/InputTypeControl';
import RichTextLabelControl from '../components/RichTextLabelControl';
import SectionSeparator from '../components/SectionSeparator';
import ReservedNodeIndication from '../components/ReservedNodeIndication';
import FieldNameControl from '../components/FieldNameControl';
import EditViewSectionContainer from '../EditViewSectionContainer';
import HelperTextControl from '../components/HelperTextControl';
import UrlParamControl from '../components/UrlParamControl';
import { ADVANCED_COLLAPSIBLE_HEADER } from '../FormEditorEditQuestion';

import { updateFormNodeValue } from '../../../actions/nodeActions';
import { getEditFormNodeId, getEditFormNodeName } from '../../../selectors';
import { isTemporaryId } from '../../../utils/formValidations';

const getLabelByName = (name) =>
    ({
        [NODE_NAME_DATE_RANGE_START_DATE]: 'Start Date',
        [NODE_NAME_DATE_RANGE_END_DATE]: 'End Date',
        [NODE_NAME_DATE_RANGE_START_TIME]: 'Start Time',
        [NODE_NAME_DATE_RANGE_END_TIME]: 'End Time',
    }[name] || name);

const getTooltipContent = (name) => `You may modify the label of this question.
RSVP answers will appear in the "${getLabelByName(name)}" column of the guest list`;

const DateRangeChild = () => {
    const dispatch = useDispatch();
    const [isTouched, setIsTouched] = useState(false);
    const formNodeId = useSelector(getEditFormNodeId);
    const formNodeName = useSelector(getEditFormNodeName);

    const updateCodeFromLabel = useCallback((label) => {
        if (isTemporaryId(formNodeId) && !isTouched) {
            dispatch(updateFormNodeValue(formNodeId, 'code', label));
        }
    });

    return (
        <React.Fragment>
            <EditViewSectionContainer>
                <SuiContainer variation="flex-group">
                    <RichTextLabelControl formNodeId={formNodeId} onChange={updateCodeFromLabel} />
                </SuiContainer>
                <ReservedNodeIndication
                    label={getLabelByName(formNodeName)}
                    tooltip={getTooltipContent(formNodeName)}
                />
                <SectionSeparator />
                <SuiContainer variation="flex-group">
                    <InputTypeControlDisableable disabled formNodeId={formNodeId} />
                </SuiContainer>
                <SectionSeparator />
                <FieldNameControl formNodeId={formNodeId} onChange={(value) => setIsTouched(!!value)} />
            </EditViewSectionContainer>

            <SuiCollapsible
                fullWidth
                header={ADVANCED_COLLAPSIBLE_HEADER}
                content={
                    <EditViewSectionContainer>
                        <SuiContainer variation="flex-group">
                            <HelperTextControl formNodeId={formNodeId} />
                        </SuiContainer>

                        <SuiContainer variation="flex-group">
                            <UrlParamControl formNodeId={formNodeId} />
                        </SuiContainer>
                    </EditViewSectionContainer>
                }
            />
        </React.Fragment>
    );
};

DateRangeChild.propTypes = {};

DateRangeChild.defaultProps = {};

export default DateRangeChild;
